"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moving = false;
var timeout = null;
function setMoving() {
    moving = true;
    if (timeout) {
        clearTimeout(timeout);
        timeout = null;
    }
    timeout = setTimeout(function () {
        moving = false;
        timeout = null;
    }, 250);
}
exports.setMoving = setMoving;
function mouseoverFocus(e) {
    if (!moving)
        return;
    e.target.focus();
}
function makeMouseoverFocusable(elt) {
    if (elt.getAttribute("tabindex") == undefined) {
        elt.tabIndex = 0;
    }
    elt.addEventListener("mouseenter", mouseoverFocus);
}
exports.makeMouseoverFocusable = makeMouseoverFocusable;
function removeMouseoverFocusable(elt) {
    elt.removeEventListener("mouseenter", mouseoverFocus);
}
exports.removeMouseoverFocusable = removeMouseoverFocusable;
//# sourceMappingURL=mouseover-focusable.js.map